import React, { Component } from 'react';
import { /*Link,*/ withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ModalErrorTimeout from './ModalErrorTimeout';
import { Box, Text, Anchor, Table, TableBody, TableRow, TableCell } from 'grommet';


class GestioneRichiesteStep1 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props)
        this.state = {
            data: this.props.values.data === [] ? [] : this.props.values.data,
        }
    }

    saveAndContinue = (e) => {
        e.preventDefault()
        this.props.nextStep()
    }

    /*componentWillMount() {
        this.props.listaGestori();
    }*/

    render() {
        const data = this.props.values.data

        return (
            <Box className='contentbox'>
                {this.props.values.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='start' style={{ margin: '20px 22px' }}>
                   <Text className='titlehome'> <h1>GESTIONE RICHIESTE</h1></Text>
                    <Text className='subtitlehome'><h3>Seleziona il gestore che ti interessa</h3></Text>
                </Box>

                <Box pad='medium' direction='row'>
                    <Box>
                        <Table>
                            <TableBody id="tableGest">
                                {data.map((el, i) => (
                                    // <Box direction='row' key={i}>
                                    //     <Anchor style={{ fontFamily: 'Segoe UI Semibold', width: '150px', textAlign: 'left' }} onClick={() => this.props.getGestore(el)} className='manager-link'>Gestore {el.eboxCode}</Anchor>-
                                    //     <Text style={{ fontSize: '16px' }}>{el.managerCode} / {el.description}</Text>
                                    //     <Box>
                                    //         {el.flSuspended !== "" ? "ANNULLATO" : null}
                                    //     </Box>
                                    // </Box>
                                    <TableRow key={i}>
                                        <TableCell style={{display:"inline", paddingRight: "0"}}>
                                            <Anchor href="#" style={{ fontFamily: 'Segoe UI Semibold', width: '120px', textAlign: 'left', display:"inline-block" }} onClick={e => { e.preventDefault(); this.props.getGestore(el); }} className='manager-link'>Gestore {el.eboxCode}</Anchor>-
                                            <Text style={{ fontSize: '16px' }}>{el.managerCode} / {el.description}</Text>
                                        </TableCell>
                                        <TableCell style={{paddingLeft: "0", height: "36px"}}>
                                            <Text style={{ fontSize: '16px' }}>{el.flSuspended === "1" ? "ANNULLATO" : null}</Text>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Box>
                </Box>
            </Box>

        )
    }
}

export default GestioneRichiesteStep1 = withRouter(GestioneRichiesteStep1);